import {Injectable} from "@angular/core";
import {Storage} from "@ionic/storage";
import moment from 'moment-timezone';

const timezoneStorageKey = 'tolkify_app_timezone';
// const defaultTimezone = moment.tz.guess();

@Injectable()
export class TimezoneService {
  timezones = [
    "Europe/Stockholm",
    "Europe/Copenhagen",
    "Europe/Tallinn",
    "Europe/Zurich",
    "Europe/Berlin",
    "Europe/Oslo",
    "Europe/Helsinki"
  ];

  constructor(private storage: Storage) {
  }

  getTimezone() {
    //return localStorage.getItem(timezoneStorageKey) || defaultTimezone;
    return "Europe/Copenhagen"; // Until we operate in Denmark only
  }

  setTimezone(timezone: string) {
    this.storage.ready().then(() => this.storage.set(timezoneStorageKey, timezone));

    moment.tz.setDefault(timezone);
  }

  init() {
    let timezone = this.getTimezone();
    moment.tz.setDefault(timezone);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/timezone-picker/timezone.service.ts